import React from 'react'

const Services = () => {
  return (
    <div><h2>This is Services Page</h2></div>
  )
}

export default Services